import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import { InstallerVersionListResp, InstallerVersionReq, Response } from '../models';
import { ApiService } from './api.service';

// Same ArtifactType the Worker's own self-update already queries
// (ExtractorInstallationVerificationCommand) - the installer .exe is released under the same
// version number as the Worker zip, so looking this up gives the version to build the installer
// filename from too (ToothTeller.Extractor.Installer_{versionNo}.exe), with no separate row needed.
export const EXTRACTOR_PACKAGE_ARTIFACT_TYPE = 'ExtractorPackage';

@Injectable({
  providedIn: 'root',
})
export class InstallerVersionService {
  private api: string = CONTROLLERS.INSTALLER_VERSION;

  constructor(private apiService: ApiService) {}

  getInstallerVersionList(
    request: InstallerVersionReq
  ): Observable<Response<InstallerVersionListResp>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.INSTALLER_VERSION.LIST}`, request);
  }
}
